// extracted by mini-css-extract-plugin
module.exports = {"root":"_1pT2C","iconContainer":"_1_j9J","iconLabel":"_3-dJO"};